import React, { PureComponent } from 'react';
import { bool } from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';
import Observer from '../Profilers/Observer';

const Container = styled.div.withConfig({ componentId: 'sc-rxlcez-0' })`
  width: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'width' does not exist on type 'ThemedSty... Remove this comment to see the full error message
    props.width};
  height: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'height' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.height};
  border-radius: 10px;
  background-color: ${colors.borderLine};
`;

const Fill = styled(Container).withConfig({ componentId: 'sc-rxlcez-1' })`
  width: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'fillWidth' does not exist on type 'Theme... Remove this comment to see the full error message
    props.fillWidth};
  height: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'height' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.height};
  background-color: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'fillColor' does not exist on type 'Theme... Remove this comment to see the full error message
    props.fillColor};
  transition: width 1000ms ease-in-out;
`;

type OwnProps = {
  startValue?: number;
  currentValue: number;
  upperBound: number;
  fillColor?: string;
  height?: string;
  width: string;
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  shouldAnimateOnRender: bool;
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  shouldAnimateOnSawComponent: bool;
};

type State = any;

type Props = OwnProps & typeof ProgressBar.defaultProps;

class ProgressBar extends PureComponent<Props, State> {
  static defaultProps = {
    fillColor: colors.purpSizzurp,
    height: '5px',
    startValue: 0,
  };

  constructor(props: Props) {
    super(props);
    const { startValue, upperBound } = this.props;
    this.state = { fillWidth: this.getCalculatedFillWidth(startValue, upperBound) };
  }

  getCalculatedFillWidth = (value: any, upperBound: any) => {
    if (value >= upperBound) return '100%';

    return `${Math.round((value / upperBound) * 100)}%`;
  };

  handleAnimateProgressBar = () => {
    const { currentValue, upperBound } = this.props;
    setTimeout(
      () => {
        this.setState({ fillWidth: this.getCalculatedFillWidth(currentValue, upperBound) });
      },

      200
    );
  };

  render = () => {
    const { width, height, fillColor, shouldAnimateOnRender, shouldAnimateOnSawComponent } =
      this.props;
    const { fillWidth } = this.state;

    return (
      <Observer
        handleRenderComponent={() => shouldAnimateOnRender && this.handleAnimateProgressBar()}
        handleSawComponent={() => shouldAnimateOnSawComponent && this.handleAnimateProgressBar()}
      >
        {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'width' does not exist on type 'Intrinsic... Remove this comment to see the full error message */}
        <Container height={height} width={width}>
          {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'fillColor' does not exist on type 'Intri... Remove this comment to see the full error message */}
          <Fill fillColor={fillColor} fillWidth={fillWidth} height={height} />
        </Container>
      </Observer>
    );
  };
}

export default ProgressBar;
